<template>
  <div v-show="parentContainer.pageCount > 1" class="rfp-ratings-carousel-pagination">
    <div class="rfp-ratings-carousel-dot-container">
      <div
        v-for="(page, index) in parentContainer.pageCount"
        :key="index"
        class="rfp-ratings-carousel-dot"
        :class="{ 'rfp-ratings-carousel-dot--active': index === parentContainer.currentPage }"
        :style="`
          margin-top: ${parentContainer.paginationPadding * 2}px;
          padding: ${parentContainer.paginationPadding}px;
        `"
        @click="parentContainer.goToPage(index)"
      >
        <div
          class="rfp-ratings-carousel-dot-inner"
          :style="`
            width: ${parentContainer.paginationSize}px;
            height: ${parentContainer.paginationSize}px;
            background: ${index === parentContainer.currentPage ? parentContainer.paginationActiveColor : parentContainer.paginationColor};
          `"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
export default {
  name: 'rfp-ratings-pagination',
  data() {
    return {
      parentContainer: this.$parent,
    };
  },
};
</script>
